import {Component, input, InputSignal} from '@angular/core';

@Component({
  selector: 'icon-facebook',
  imports: [],
  template: `
    <svg xmlns="http://www.w3.org/2000/svg" fill="none" [attr.width]="size()" [attr.height]="size()"
         viewBox="0 0 24 24">
      <path stroke="currentColor" stroke-linejoin="round" stroke-width="1.5"
            d="M6.18182 10.3333C5.20406 10.3333 5 10.5252 5 11.4444v1.6667c0 .9193.20406 1.1111 1.18182
            1.1111h2.36363v6.6667c0 .9192.20406 1.1111 1.18182 1.1111h2.36363c.9778 0 1.1818-.1919 1.1818-1.1111v-6.6667h2.654c.7416
            0 .9327-.1355 1.1364-.8058l.5065-1.6667c.3489-1.1483.1339-1.4164-1.1364-1.4164h-3.1605V7.55556c0-.61365.5291-1.11112
            1.1818-1.11112h3.3637c.9777 0 1.1818-.19185 1.1818-1.11111V3.11111C19 2.19185 18.7959 2 17.8182 2h-3.3637C11.191
            2 8.54545 4.48731 8.54545 7.55556v2.77774H6.18182Z" clip-rule="evenodd" />
    </svg>
  `,
  styles: ``
})
export class IconFacebookComponent {
  size: InputSignal<number> = input<number>(24);
}
